// trimmed Bootstrap and Kendo theme builds; see the comments in each file
// before adding a component that is not styled yet
import "./themes/bootstrap.scss";
import "./themes/kendo.scss";

import "./themes/wib.css";

import * as React from "react";
import * as ReactClient from "react-dom/client";

import App from "./components/App";
import { initializeMsal } from "./common/msal";

// msal-browser v3+ requires initialize() to resolve before any other MSAL API
// is used, so defer the first render until the singleton is ready.
initializeMsal().then(() => {
  const element = document.getElementById("app-container");
  const root = ReactClient.createRoot(element);

  // StrictMode is development-only (a no-op in production builds). It
  // double-invokes render and effects to surface effects that are not
  // idempotent, and warns about deprecated APIs. Both matter here: the React
  // Compiler (opt-in) and Fast Refresh assume effects can re-run safely.
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
});
